import React, { useContext, useEffect, useMemo, useState } from "react";
import moment from "moment";
import "moment/locale/es";
import { Link, useNavigate } from "react-router-dom";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import {
  Input,
  List,
  Modal,
  Radio,
  Steps,
  message,
  Select as SelectAntd,
  Checkbox,
  Button,
} from "antd";
import esLocale from "@fullcalendar/core/locales/es";
import { getCitasResults, getGestoresResults } from "../../services/api";
import { Calendar as ReactCalendar } from "react-calendar";
import { debounce } from "lodash";
import { getPatients } from "../../services/patient";
import Select from "react-select";
import {
  pasos,
  rutaPaciente,
  coloresGestores,
} from "../../utils/enums/calendario";
import { actividadesCode } from "../../utils/enums/statusCodes";
import { programarCita } from "../../services/actividades";
import { SubscripcionContext } from "../../context/SubscripcionContextProvider";
import {
  obtenerCitas,
  solicitarSubscripcion,
} from "../../services/subscripciones";
import { ExclamationCircleFilled } from "@ant-design/icons";
import SubscripcionesModal from "./componentes/SubscripcionesModal";
import SolicitudesModal from "./componentes/SolicitudesModal";
import Calendario from "./componentes/Calendario";
const { Step } = Steps;

const Calendar = () => {
  const { solicitudes, subscripciones, actualizarInformacion } =
    useContext(SubscripcionContext);
  const [menu, setMenu] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [defaultEvents, setDefaultEvents] = useState("");
  const [modalProgramarVisible, setModalProgramarVisible] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedGestorProgramar, setSelectedGestorProgramar] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedHour, setSelectedHour] = useState(null);
  const [lugarCita, setLugarCita] = useState("");
  const [descripcionCita, setDescripcionCita] = useState("");
  const [notificarPaciente, setNotificarPaciente] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [defaultPacientes, setDefaultPacientes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [citasPacienteSelected, setCitasPacienteSelected] = useState([]);
  const [citaSelected, setCitaSelected] = useState(null);
  const [selectedCitaGestor, setSelectedCitaGestor] = useState(null);
  const [loadingProgramar, setLoadingProgramar] = useState(false);

  const [gestoresData, setGestoresData] = useState(null);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [selectedGestor, setSelectedGestor] = useState(null);
  const [selectedGestores, setSelectedGestores] = useState([]);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const navigate = useNavigate();

  const [modalVisible, setModalVisible] = useState(false);
  const [modalSolicitudesVisible, setModalSolicitudesVisible] = useState(false);
  const [modalSubscripcionesVisible, setModalSubscripcionesVisible] =
    useState(false);

  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);

  const [currentEvents, setscurrentEvents] = useState([]);

  const [gestorStepSelected, setGestorStepSelected] = useState(false);
  const [citaStepSelected, setCitaStepSelected] = useState(false);

  const handleCitaSelection = (cita) => {
    setCitaSelected(cita.id);
    setCitaStepSelected(!!cita);
  };

  const handlePatientSelect = (selectedOption) => {
    setSelectedPatient(selectedOption);
    fetchCitaPaciente(selectedOption.value);
  };

  const delayedSearch = debounce(async (text) => {
    setIsLoading(true);
    try {
      const results = await getPatients({
        SearchText: text,
        pageSize: 15,
      });
      setSearchResults(results.data);
    } catch (error) {
      console.error("Error searching patients:", error);
    } finally {
      setIsLoading(false);
    }
  }, 2000);

  useEffect(() => {
    if (debouncedSearchTerm) {
      delayedSearch(debouncedSearchTerm);
    } else {
      setSearchResults([]);
    }
    return delayedSearch.cancel;
  }, [debouncedSearchTerm]);

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      setDebouncedSearchTerm(searchText);
    }, 300);

    return () => clearTimeout(delaySearch);
  }, [searchText]);

  const handleInputPacienteChange = (inputValue) => {
    setSearchText(inputValue);
  };

  const handleIrAPaciente = () => {
    navigate(`${rutaPaciente}${selectedEvent.extendedProps.afiliado}`);
  };

  const handleGestorSelection = async (gestorId) => {
    const isSelected = selectedGestores.includes(gestorId);
    let updatedSelectedGestores = [];
    if (isSelected) {
      updatedSelectedGestores = selectedGestores.filter(
        (id) => id !== gestorId
      );
    } else {
      updatedSelectedGestores = [...selectedGestores, gestorId];
    }
    setSelectedGestores(updatedSelectedGestores);

    await fetchData(updatedSelectedGestores, false);
    fetchData(updatedSelectedGestores);
  };

  const handleCerrarModalPacienteInfo = () => {
    setModalVisible(false);
    setCurrentStep(0);
    resetStepStates();
  };

  const fetchData = async (gestoresSeleccionados, incluirSubscritos = true) => {
    try {
      const gestorActual = localStorage.getItem("username");
      const gestoresConActual = [...gestoresSeleccionados, gestorActual];
      const citas = await obtenerCitas({
        gestores: gestoresConActual,
        incluirSubscritos: incluirSubscritos,
      });
      if (citas && citas.length > 0) {
        const formattedEvents = [];
        const processedIds = new Set();
        citas.forEach((item) => {
          if (!processedIds.has(item.id)) {
            processedIds.add(item.id);

            const gestorData = gestoresData.find(
              (g) => g.usuarioId === item.responsable
            );
            const color = gestorData ? gestorData.color : "#FF5733";

            formattedEvents.push({
              title: item.actividadDe,
              start: item.fechaAgendamiento,
              end: item.fechaLimite,
              responsable: item.responsable,
              afiliado: item.afiliado,
              backgroundColor: color,
            });
          }
        });
        setscurrentEvents(formattedEvents);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const fetchGestoresData = async () => {
      try {
        const data = await getGestoresResults(true);
        const gestoresWithColors = assignColorsToGestores(data);
        setGestoresData(gestoresWithColors);
      } catch (error) {
        console.error(error);
      }
    };

    fetchGestoresData();
  }, []);

  const fetchCitaPaciente = async (paciente) => {
    try {
      const data = await getCitasResults(
        null,
        paciente,
        actividadesCode.Activa.value,
        null,
        "2"
      );
      if (data && data.length > 0) {
        setCitasPacienteSelected(data);
      } else {
        setCitasPacienteSelected([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const fetchCitasGestorData = async () => {
      const gestor = localStorage.getItem("username");

      try {
        setscurrentEvents([]);
        fetchData([gestor], true);
      } catch (error) {
        console.error(error);
      }
    };

    if (gestoresData) {
      fetchCitasGestorData();
    }
  }, [gestoresData]);

  const [calendarHeight, setCalendarHeight] = useState(0);

  useEffect(() => {
    const calendarElement = document.getElementById("calendar");

    if (calendarElement) {
      setCalendarHeight(calendarElement.clientHeight - 100);
    }
  }, [gestoresData]);

  const filteredGestores = useMemo(() => {
    if (!gestoresData) return [];
    return gestoresData.filter((gestor) =>
      gestor.gestor.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
    );
  }, [gestoresData, debouncedSearchTerm]);

  const handleInputChange = (inputValue) => {};

  useEffect(() => {
    let elements = Array.from(
      document.getElementsByClassName("react-datepicker-wrapper")
    );
    elements.map((element) => element.classList.add("width-100"));
  }, []);

  const handleEventClick = (clickInfo) => {
    setSelectedEvent(clickInfo.event);
    setModalVisible(true);
  };

  const handleModalProgramarCancel = () => {
    setModalProgramarVisible(false);
    setCurrentStep(0);
    resetStepStates();
  };

  const renderEventContent = (eventInfo) => {
    return (
      <div
        style={{
          backgroundColor: eventInfo.event.backgroundColor,
          color: "#fff",
          borderRadius: "5px",
          padding: "2px 5px",
          cursor: "pointer",
        }}
      >
        {eventInfo.timeText && <span>{eventInfo.timeText}</span>}
        <strong>{eventInfo.event.title}</strong>
      </div>
    );
  };

  const assignColorsToGestores = (gestores) => {
    return gestores.map((gestor, index) => {
      return {
        ...gestor,
        color: coloresGestores[index % coloresGestores.length],
      };
    });
  };

  const handleGuardarClick = async () => {
    try {
      setIsLoading(true);
      const fechaSeleccionada = selectedDate || moment().format("YYYY-MM-DD");
      const [horaInicio, horaFin] = selectedHour.split(" - ");

      const horaInicioSinAmPm = horaInicio.replace(/\s(a|p)m$/i, "");
      const horaFinSinAmPm = horaFin.replace(/\s(a|p)m$/i, "");
      const dataToSend = {
        idCita: citaSelected,
        gestor: selectedCitaGestor.value,
        fecha: fechaSeleccionada,
        hora: `${horaInicioSinAmPm}-${horaFinSinAmPm}`,
        lugar: lugarCita,
        descripcion: descripcionCita,
        notificar: notificarPaciente,
        afiliado: selectedPatient.value,
      };
      var respuesta = await programarCita(dataToSend);
      if (respuesta.data === true)
        message.success("Cita programada exitosamente.");
      setModalProgramarVisible(false);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error programando cita:", error);
      message.error(
        "Error programando cita. Por favor, inténtelo de nuevo más tarde."
      );
    } finally {
      setCurrentStep(0);
      resetStepStates();
    }
  };

  const handleSiguientePasoClick = () => {
    if (currentStep === 3) {
      setModalProgramarVisible(false);
      setCurrentStep(0);
    } else {
      setCurrentStep(currentStep + 1);
    }
  };
  const handleSelectedCitaGestor = (record) => {
    setSelectedCitaGestor(record);
    setGestorStepSelected(!!record);
  };
  const handleAsignarClick = (hora) => {
    setSelectedHour(hora);
    setCurrentStep(currentStep + 1);
  };

  const resetStepStates = () => {
    setGestorStepSelected(false);
    setCitaStepSelected(false);
    setSelectedGestorProgramar("");
    setSelectedCitaGestor("");
    setLugarCita("");
    setDescripcionCita("");
    setNotificarPaciente(true);
  };

  const handleModalSolicitudesCancel = () => {
    setModalSolicitudesVisible(false);
  };

  const handleModalSubscripcionesCancel = () => {
    setModalSubscripcionesVisible(false);
  };

  const handleSolicitarSubscripcion = async (gestorSeleccionado) => {
    const gestor = gestoresData.find(
      (gestor) => gestor.id === gestorSeleccionado
    );
    const { confirm } = Modal;
    try {
      confirm({
        title: `¿Está seguro que desea solicitar subscribirse al calendario de ${gestor.gestor} ?`,
        icon: <ExclamationCircleFilled />,
        centered: true,
        content:
          "Las suscripciones aparecerán en la sección de suscripciones una vez que el gestor las haya aceptado.",
        okText: "Si",
        cancelText: "No",
        onOk() {
          return new Promise((resolve, reject) => {
            solicitarSubscripcion({ gestor: gestor.usuarioId })
              .then(() => {
                message.success(
                  "Solicitud de subscripción enviada exitosamente."
                );
                setIsLoading(false);
                resolve(); // Resuelve la promesa externa
              })
              .catch((error) => {
                setIsLoading(false);
                reject(error); // Rechaza la promesa externa con el error
              });
          });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const tituloPasos = [
    pasos.SELECCIONAR_GESTOR,
    pasos.SELECCIONAR_CITA,
    pasos.SELECCIONAR_FECHA_CITA,
    pasos.INGRESAR_UBICACION,
  ];

  const stepsContent = [
    <div style={{ marginTop: "40px" }}>
      <Select
        placeholder="Selecciona al gestor responsable"
        isClearable
        value={selectedCitaGestor}
        onChange={(gestor) => handleSelectedCitaGestor(gestor)}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (baseStyles, state) => ({
            ...baseStyles,
            boxShadow: state.isFocused ? "0 0 0 1px #2e37a4" : "none",
            "&:hover": {
              borderColor: state.isFocused
                ? "none"
                : "2px solid rgba(46, 55, 164, 0.1)",
            },
            borderRadius: "10px",
            fontSize: "14px",
            minHeight: "45px",
          }),
          dropdownIndicator: (base, state) => ({
            ...base,
            transform: state.selectProps.menuIsOpen
              ? "rotate(-180deg)"
              : "rotate(0)",
            transition: "250ms",
            width: "35px",
            height: "35px",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 10000,
          }),
        }}
        options={
          gestoresData
            ? gestoresData.map((gestor) => ({
                value: gestor.usuarioId,
                label: gestor.gestor,
              }))
            : []
        }
      />
    </div>,

    <div style={{ marginTop: "40px" }}>
      <Select
        placeholder="Buscar el paciente"
        value={selectedPatient}
        onInputChange={handleInputPacienteChange}
        isLoading={isLoading}
        onChange={handlePatientSelect}
        loadingMessage={() => "Cargando pacientes..."}
        noOptionsMessage={() => ""}
        onClearIndicatorMouseDown={() => {
          handlePatientSelect(null);
        }}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (baseStyles, state) => ({
            ...baseStyles,
            boxShadow: state.isFocused ? "0 0 0 1px #2e37a4" : "none",
            "&:hover": {
              borderColor: state.isFocused
                ? "none"
                : "2px solid rgba(46, 55, 164, 0.1)",
            },
            borderRadius: "10px",
            fontSize: "14px",
            minHeight: "45px",
          }),
          dropdownIndicator: (base, state) => ({
            ...base,
            transform: state.selectProps.menuIsOpen
              ? "rotate(-180deg)"
              : "rotate(0)",
            transition: "250ms",
            width: "35px",
            height: "35px",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 10000,
          }),
        }}
        components={{
          IndicatorSeparator: () => null,
        }}
        options={(searchResults.length > 0
          ? searchResults
          : defaultPacientes
        ).map((patient) => ({
          value: patient.id,
          label: `${patient.fullName}`,
        }))}
      />

      <label className="form-label" style={{ fontSize: "20px" }}></label>
      <div style={{ maxHeight: "100%" }}>
        {selectedPatient ? (
          citasPacienteSelected.length > 0 ? (
            <ul className="radio-list" style={{ maxHeight: "100%" }}>
              {citasPacienteSelected.map((cita, index) => (
                <li
                  key={index}
                  className="list-item d-flex justify-content-between align-items-center"
                >
                  <div className="d-flex align-items-center">
                    <Radio
                      onChange={() => handleCitaSelection(cita)}
                      checked={citaSelected === cita.id}
                      id={`item${cita.id}`}
                      sx={{ fontSize: 12 }}
                    />
                    <label
                      htmlFor={`item${cita.id}`}
                      className="radio-label fs-9"
                    >
                      {cita.actividadDe}
                    </label>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p>Este paciente no tiene citas creadas.</p>
          )
        ) : (
          <p></p>
        )}
      </div>
    </div>,
    <div style={{ display: "flex", marginTop: "40px" }}>
      <div style={{ flex: 1, marginRight: "50px", height: "200px" }}>
        <ReactCalendar
          initialView="dayGridMonth"
          locale="es"
          selectable={true}
          onChange={(date) => setSelectedDate(date)}
        />
      </div>
      <div style={{ flex: 1, overflowY: "auto", maxHeight: "300px" }}>
        <List
          bordered
          dataSource={Array.from({ length: 18 }).map((_, index) => {
            const hour = Math.floor(index / 2) + 8;
            const minute = index % 2 === 0 ? "00" : "30";
            const nextHour = index % 2 !== 0 ? hour + 1 : hour;
            const nextMinute = index % 2 === 0 ? "30" : "00";
            const ampm1 = hour < 12 ? "am" : "pm";
            const ampm2 = nextHour < 12 ? "am" : "pm";
            const formattedHour1 =
              hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
            const formattedHour2 =
              nextHour === 0 ? 12 : nextHour > 12 ? nextHour - 12 : nextHour;
            return {
              hora: `${String(formattedHour1).padStart(
                2,
                "0"
              )}:${minute} ${ampm1} - ${String(formattedHour2).padStart(
                2,
                "0"
              )}:${nextMinute} ${ampm2}`,
            };
          })}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Button
                  key="asignar"
                  onClick={() => handleAsignarClick(item.hora)}
                >
                  Asignar
                </Button>,
              ]}
            >
              {item.hora}
            </List.Item>
          )}
        />
      </div>
    </div>,
    <div style={{ marginTop: "40px" }}>
      <div style={{ marginBottom: "10px" }}>
        <label htmlFor="lugarCita">Lugar de la cita</label>
        <Input id="lugarCita" onChange={(e) => setLugarCita(e.target.value)} />
      </div>
      <div style={{ marginBottom: "10px" }}>
        <label htmlFor="descripcionCita">Descripción de la cita</label>
        <Input
          id="descripcionCita"
          onChange={(e) => setDescripcionCita(e.target.value)}
        />
      </div>
      <div style={{ marginBottom: "10px" }}>
        <label htmlFor="notificarPaciente">Notificar al paciente?</label>
        <SelectAntd
          id="notificarPaciente"
          defaultValue={"true"}
          onChange={(value) =>
            setNotificarPaciente(value === "true" ? true : false)
          }
        >
          <Option value={"true"}>Si</Option>
          <Option value={"false"}>No</Option>
        </SelectAntd>
      </div>
    </div>,
  ];

  return (
    <>
      <div className="main-wrapper">
        {/* Page Header */}
        <div className="page-header">
          <div className="row align-items-center">
            <div className="col">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admindashboard">Acceso</Link>
                </li>
                <li className="breadcrumb-item">
                  <i className="feather-chevron-right">
                    <FeatherIcon icon="chevron-right" />
                  </i>
                </li>
                <li className="breadcrumb-item active">Calendario</li>
              </ul>
            </div>
          </div>
          {/* Agregar el elemento select y la etiqueta aquí */}
          <div className="row mb-3">
            <Calendario
              currentEvents={currentEvents}
              handleEventClick={handleEventClick}
              selectedEvent={selectedEvent}
              modalVisible={modalVisible}
              handleCerrarModalPacienteInfo={handleCerrarModalPacienteInfo}
              handleIrAPaciente={handleIrAPaciente}
            />
            <div className="col-lg-4 col-md-4">
              <div>
                <Button
                  type="link"
                  className="btn btn-primary"
                  style={{
                    width: "100%",
                    backgroundColor: "var(--primary-color)",
                    color: "#fff",
                    position: "relative",
                  }}
                  onClick={() => setModalSolicitudesVisible(true)}
                >
                  Solicitudes
                  {solicitudes && solicitudes.length > 0 && (
                    <span
                      className="pulse"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    ></span>
                  )}
                </Button>

                <Button
                  type="link"
                  className="btn btn-primary"
                  style={{
                    width: "100%",
                    backgroundColor: "var(--primary-color)",
                    color: "#fff",
                    marginTop: "2%",
                  }}
                  onClick={() => setModalSubscripcionesVisible(true)}
                >
                  Suscripciones
                </Button>
              </div>
              <Button
                type="link"
                className="btn btn-primary"
                style={{
                  backgroundColor: "#0d6efd",
                  color: "#fff",
                  width: "100%",
                  marginTop: "2%",
                }}
                onClick={() => setModalProgramarVisible(true)}
              >
                Programar consulta
              </Button>
              <div
                className="card"
                style={{ height: calendarHeight, marginTop: "10px" }}
              >
                <SelectAntd
                  placeholder="Suscribirse a calendario"
                  onInputChange={handleInputChange}
                  onChange={(gestorSeleccionado) =>
                    handleSolicitarSubscripcion(gestorSeleccionado)
                  }
                  options={
                    gestoresData
                      ? gestoresData.map((gestor) => ({
                          value: gestor.id,
                          label: gestor.gestor,
                        }))
                      : []
                  }
                />
                <div style={{ marginTop: "20px" }}></div>
                <label
                  className="form-label"
                  style={{ fontSize: "14px", marginLeft: "20px" }}
                >
                  Selecciona un gestor para ver su calendario :
                </label>
                {/* Lista de checkbox aquí */}
                <ul className="checkbox-list" style={{ maxHeight: "80%" }}>
                  {gestoresData &&
                    gestoresData.map((gestor, index) => (
                      <li
                        key={index}
                        className="list-item d-flex justify-content-between align-items-center"
                      >
                        <div className="d-flex align-items-center">
                          <Checkbox
                            onChange={() =>
                              handleGestorSelection(gestor.usuarioId)
                            }
                            disabled={subscripciones.some(
                              (sub) => sub.gestor == gestor.gestor
                            )}
                            id={`item${gestor.usuarioId}`}
                            sx={{ fontSize: 12 }}
                          />
                          <label
                            htmlFor={`item${gestor.usuarioId}`}
                            className="checkbox-label fs-9"
                            style={{ marginLeft: "20px" }}
                          >
                            {gestor.gestor}
                            {subscripciones.some((sub) => sub.gestor == gestor.gestor) && (
                                <span style={{ marginLeft: "5px", fontSize: "10px", color: "green" }}>(suscrito)</span>
                            )}
                          </label>
                        </div>
                        <div
                          className="color-circle"
                          style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            backgroundColor: gestor.color,
                            marginLeft: "10px",
                          }}
                        ></div>
                      </li>
                    ))}
                </ul>
                {/* Fin de la lista de checkbox */}
              </div>
            </div>
            {/* Fin del nuevo bloque */}
          </div>
        </div>
        <Modal
          title="Selecciona un gestor para programar la cita"
          visible={showScheduleModal}
          onOk={() => handleScheduleAppointment(selectedGestor)}
          onCancel={() => setShowScheduleModal(false)}
          okText="Confirmar Cita"
          cancelText="Cancelar"
          style={{ maxHeight: "80vh" }}
          bodyStyle={{ maxHeight: "calc(80vh - 108px)", overflowY: "auto" }}
        >
          <div className="form-group">
            <input
              className="form-control"
              type="text"
              placeholder="Buscar gestor"
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ marginBottom: "10px" }}
            />
          </div>
          <ul
            className="radio-list"
            style={{ maxHeight: "calc(100% - 40px)", overflowY: "auto" }}
          >
            {filteredGestores.map((gestor, index) => (
              <li
                key={index}
                className="list-item d-flex justify-content-between align-items-center"
              >
                <div className="d-flex align-items-center">
                  <input
                    type="radio"
                    id={`item${index}`}
                    name="gestorRadio"
                    checked={selectedGestorProgramar === gestor}
                    onChange={() => {
                      setSelectedGestorProgramar(gestor);
                    }}
                    style={{ fontSize: "12px" }}
                  />
                  <label htmlFor={`item${index}`} className="radio-label fs-9">
                    {gestor.gestor}
                  </label>
                </div>
              </li>
            ))}
          </ul>
        </Modal>
        <Modal
          title="Programar cita"
          visible={modalProgramarVisible}
          onCancel={handleModalProgramarCancel}
          footer={[
            <Button key="cancel" onClick={handleModalProgramarCancel}>
              Cancelar
            </Button>,
            <Button
              key="save"
              loading={isLoading}
              type="primary"
              onClick={
                currentStep === 3
                  ? handleGuardarClick
                  : handleSiguientePasoClick
              }
              disabled={
                currentStep === 0
                  ? !gestorStepSelected
                  : currentStep === 1
                    ? !citaStepSelected
                    : lugarCita.trim() === "" || descripcionCita.trim() === ""
              }
            >
              {currentStep === 3 ? "Guardar" : "Siguiente"}
            </Button>,
          ]}
          centered
          width="45%"
        >
          <Steps current={currentStep}>
            {tituloPasos.map((title) => (
              <Step key={title} title={title} />
            ))}
          </Steps>
          {stepsContent[currentStep]}
        </Modal>

        <SolicitudesModal
          visible={modalSolicitudesVisible}
          solicitudes={solicitudes}
          actualizarInformacion={actualizarInformacion}
          handleModalSolicitudesCancel={handleModalSolicitudesCancel}
        />

        <SubscripcionesModal
          visible={modalSubscripcionesVisible}
          subscripciones={subscripciones}
          actualizarInformacion={actualizarInformacion}
          handleModalSubscripcionesCancel={handleModalSubscripcionesCancel}
        />
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default Calendar;
